module.exports = __webpack_public_path__ + "img/title.ddc52348.png";